import {Component, EventEmitter, Input, Output} from '@angular/core';
import {OrderItemTopping} from '../../_models/order-item-topping';
import {OrderItemToppingModifier} from '../../_models/order-item-topping-modifier';
import {OrderItem} from '../../_models/order-item';

@Component({
    selector: 'bb-display-order-item-topping',
    templateUrl: './display-order-item-topping.component.html',
    styleUrls: ['./display-order-item-topping.component.scss'],
})
export class DisplayOrderItemToppingComponent {
    @Input() orderItemTopping: OrderItemTopping;
    @Output() orderItemToppingChange = new EventEmitter<OrderItemTopping>();
    @Input() orderItem: OrderItem;
    @Input() optional = false;
    @Output() remove = new EventEmitter();

    constructor() {
    }

    includeDisplayModifier(topping: OrderItemTopping) {
        return topping.included && topping.modifiers
            && topping.modifiers.length > 0
            && topping.modifiers.some(m => !m.defaultModifier);
    }

    containsModifiers(orderItemTopping: OrderItemTopping) {
        return !!orderItemTopping && !!orderItemTopping.menuItemTopping && !!orderItemTopping.menuItemTopping.topping &&
            (orderItemTopping.menuItemTopping.topping.modifiers.length > 0
                || orderItemTopping.menuItemTopping.topping.modifierSelections.length > 0
                || orderItemTopping.menuItemTopping.topping.modifierGroups.length > 0
            );
    }

    modifiersChange(modifiers: OrderItemToppingModifier[]) {
        const orderItemTopping = new OrderItemTopping(this.orderItemTopping);
        orderItemTopping.modifiers = modifiers;
        this.orderItemToppingChange.emit(orderItemTopping);
    }
}
